module.exports = __webpack_public_path__ + "static/media/Placehold.6048a784.svg";